// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_78g","cls2":"CiterightMiniReport-cls2_yvY CiterightMiniReport-cls1_78g"};